// Default fallback locale for application,
// used for example during local development
export const DEFAULT_LOCALE = "sv";
